import { render, staticRenderFns } from "./TechKit.vue?vue&type=template&id=21a58d0c&scoped=true&"
import script from "./TechKit.vue?vue&type=script&lang=js&"
export * from "./TechKit.vue?vue&type=script&lang=js&"
import style0 from "./TechKit.vue?vue&type=style&index=0&id=21a58d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a58d0c",
  null
  
)

export default component.exports